export default __webpack_public_path__ + "static/media/permitting.a41827b5.svg";